export const nailists = [
  {
    id: 1,
    name: "山田 美咲",
    nameEn: "Misaki Yamada",
    years: 12,
    specialty: "フレンチ・ジェルアート",
    description: "ネイル歴12年のベテランネイリスト。繊細なフレンチネイルと立体的なジェルアートを得意とし、上品で長持ちする仕上がりが好評。大阪・東京の有名サロンで研鑽を積んだ確かな技術をお届けします。",
    image: "https://public.readdy.ai/ai/img_res/3b241f0a166b3c2137c59cccaa8e3d6c.jpg"
  },
  {
    id: 2,
    name: "田中 彩花",
    nameEn: "Ayaka Tanaka",
    years: 8,
    specialty: "グラデーション・ストーン装飾",
    description: "ネイル歴8年。繊細なグラデーションとストーン・パーツ装飾が得意。トレンドを押さえながらも、40代女性が日常に取り入れやすい上品なデザインを提案します。",
    image: "https://readdy.ai/api/search-image?query=beautiful%20Japanese%20professional%20woman%20nail%20artist%20portrait%2C%20late%2020s%2C%20natural%20soft%20lighting%2C%20warm%20cream%20background%2C%20elegant%20styling%2C%20confident%20friendly%20expression%2C%20luxury%20nail%20salon%20atmosphere%2C%20professional%20and%20warm%20appearance&width=400&height=400&seq=nailist2&orientation=squarish"
  },
  {
    id: 3,
    name: "鈴木 里奈",
    nameEn: "Rina Suzuki",
    years: 6,
    specialty: "ワンカラー・シンプルデザイン",
    description: "ネイル歴6年。シンプルながらも洗練されたワンカラーと大人ナチュラルデザインを得意とします。丁寧なカウンセリングと心地よい施術時間をモットーに、いつも清潔感ある仕上がりをお届けします。",
    image: "https://readdy.ai/api/search-image?query=charming%20Japanese%20professional%20woman%20nail%20technician%20portrait%2C%20mid%2020s%2C%20bright%20natural%20lighting%2C%20off-white%20background%2C%20neat%20professional%20look%2C%20warm%20inviting%20smile%2C%20upscale%20nail%20salon%20setting%2C%20clean%20and%20sophisticated%20appearance&width=400&height=400&seq=nailist3&orientation=squarish"
  }
];
